// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itapeoplepg-inline-1 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
}

.itapeoplepg-inline-2 {
  padding: 0;
  overflow-x: auto;
}

.itapeoplepg-inline-3 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
  font-size: 13px;
}

.itapeoplepg-inline-4 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
  font-size: 13px;
}

.itapeoplepg-inline-5 {
  font-family: monospace;
  font-size: 11px;
}

.itapeoplepg-inline-6 {
  font-weight: 600;
}

.itapeoplepg-inline-7 {
  font-weight: 600;
}

.itapeoplepg-inline-8 {
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #4f46e5;
  cursor: pointer;
}

.itapeoplepg-inline-9 {
  background: linear-gradient(135deg,#0f172a 0%,#1e1b4b 50%,#312e81 100%);
  border-radius: 12px;
  padding: 18px 22px;
  color: #fff;
  margin-bottom: 16px;
  position: relative;
  overflow: hidden;
}

.itapeoplepg-inline-10 {
  position: relative;
  z-index: 1;
}

.itapeoplepg-inline-11 {
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 2px;
}

.itapeoplepg-inline-12 {
  font-size: 12px;
  color: rgba(148,163,184,.8);
}

.itapeoplepg-inline-13 {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.itapeoplepg-inline-14 {
  background: #6366f1;
  padding: 4px 12px;
  border-radius: 8px;
  font-family: monospace;
  font-size: 12px;
  font-weight: 700;
}

.itapeoplepg-inline-15 {
  background: rgba(255,255,255,.1);
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
}

.itapeoplepg-inline-16 {
  font-size: 10px;
  color: rgba(148,163,184,.5);
  margin-top: 8px;
}

.itapeoplepg-inline-17 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.itapeoplepg-inline-18 {
  font-size: 12px;
  color: #94a3b8;
  padding: 8px 0;
  margin-bottom: 12px;
}

.itapeoplepg-inline-19 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  margin-bottom: 6px;
}

.itapeoplepg-inline-20 {
  font-size: 12px;
  font-weight: 600;
}

.itapeoplepg-inline-21 {
  font-size: 10px;
  color: #94a3b8;
}

.itapeoplepg-inline-22 {
  border-top: 1px solid #e2e8f0;
  margin-top: 14px;
  padding-top: 14px;
}

.itapeoplepg-inline-23 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.itapeoplepg-inline-24 {
  font-size: 12px;
  color: #94a3b8;
  padding: 8px 0;
}

.itapeoplepg-inline-25 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 10px;
}

.itapeoplepg-inline-26 {
  padding: 6px 10px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.itapeoplepg-inline-27 {
  font-size: 9px;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
}

.itapeoplepg-inline-28 {
  margin-bottom: 8px;
}

.itapeoplepg-inline-29 {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.itapeoplepg-inline-30 {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.itapeoplepg-inline-31 {
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
}

.itapeoplepg-inline-32 {
  margin-bottom: 8px;
}

.itapeoplepg-inline-33 {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.itapeoplepg-inline-34 {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.itapeoplepg-inline-35 {
  background: #eef2ff;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  color: #4338ca;
}

.itapeoplepg-inline-36 {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.itapeoplepg-inline-37 {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.itapeoplepg-inline-38 {
  background: #fffbeb;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  color: #d97706;
}

.itapeoplepg-dyn-1 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  background: var(--itapeoplepg-1-background);
  color: var(--itapeoplepg-1-color);
}

.itapeoplepg-dyn-2 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  background: var(--itapeoplepg-2-background);
  color: var(--itapeoplepg-2-color);
}

.itapeoplepg-dyn-3 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  background: var(--itapeoplepg-3-background);
  color: var(--itapeoplepg-3-color);
}

.itapeoplepg-dyn-4 {
  position: absolute;
  top: var(--itapeoplepg-4-top);
  right: var(--itapeoplepg-4-right);
  width: 140px;
  height: 140px;
  background: radial-gradient(circle,rgba(99,102,241,.15),transparent 70%);
  border-radius: 50%;
}

.itapeoplepg-dyn-5 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  background: var(--itapeoplepg-5-background);
  color: var(--itapeoplepg-5-color);
}

.itapeoplepg-dyn-6 {
  font-size: 12px;
  font-weight: 600;
  font-family: var(--itapeoplepg-6-font-family);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITAPeoplePg.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uEAAuE;EACvE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,wEAAwE;EACxE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C","sourcesContent":[".itapeoplepg-inline-1 {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 16px;\n}\n\n.itapeoplepg-inline-2 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.itapeoplepg-inline-3 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.itapeoplepg-inline-4 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.itapeoplepg-inline-5 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.itapeoplepg-inline-6 {\n  font-weight: 600;\n}\n\n.itapeoplepg-inline-7 {\n  font-weight: 600;\n}\n\n.itapeoplepg-inline-8 {\n  background: #eef2ff;\n  border: 1px solid #c7d2fe;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #4f46e5;\n  cursor: pointer;\n}\n\n.itapeoplepg-inline-9 {\n  background: linear-gradient(135deg,#0f172a 0%,#1e1b4b 50%,#312e81 100%);\n  border-radius: 12px;\n  padding: 18px 22px;\n  color: #fff;\n  margin-bottom: 16px;\n  position: relative;\n  overflow: hidden;\n}\n\n.itapeoplepg-inline-10 {\n  position: relative;\n  z-index: 1;\n}\n\n.itapeoplepg-inline-11 {\n  font-size: 17px;\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.itapeoplepg-inline-12 {\n  font-size: 12px;\n  color: rgba(148,163,184,.8);\n}\n\n.itapeoplepg-inline-13 {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.itapeoplepg-inline-14 {\n  background: #6366f1;\n  padding: 4px 12px;\n  border-radius: 8px;\n  font-family: monospace;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.itapeoplepg-inline-15 {\n  background: rgba(255,255,255,.1);\n  padding: 4px 12px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.itapeoplepg-inline-16 {\n  font-size: 10px;\n  color: rgba(148,163,184,.5);\n  margin-top: 8px;\n}\n\n.itapeoplepg-inline-17 {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.itapeoplepg-inline-18 {\n  font-size: 12px;\n  color: #94a3b8;\n  padding: 8px 0;\n  margin-bottom: 12px;\n}\n\n.itapeoplepg-inline-19 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  margin-bottom: 6px;\n}\n\n.itapeoplepg-inline-20 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.itapeoplepg-inline-21 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.itapeoplepg-inline-22 {\n  border-top: 1px solid #e2e8f0;\n  margin-top: 14px;\n  padding-top: 14px;\n}\n\n.itapeoplepg-inline-23 {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.itapeoplepg-inline-24 {\n  font-size: 12px;\n  color: #94a3b8;\n  padding: 8px 0;\n}\n\n.itapeoplepg-inline-25 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.itapeoplepg-inline-26 {\n  padding: 6px 10px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.itapeoplepg-inline-27 {\n  font-size: 9px;\n  color: #94a3b8;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.itapeoplepg-inline-28 {\n  margin-bottom: 8px;\n}\n\n.itapeoplepg-inline-29 {\n  font-size: 10px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.itapeoplepg-inline-30 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.itapeoplepg-inline-31 {\n  background: #f1f5f9;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.itapeoplepg-inline-32 {\n  margin-bottom: 8px;\n}\n\n.itapeoplepg-inline-33 {\n  font-size: 10px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.itapeoplepg-inline-34 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.itapeoplepg-inline-35 {\n  background: #eef2ff;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #4338ca;\n}\n\n.itapeoplepg-inline-36 {\n  font-size: 10px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.itapeoplepg-inline-37 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.itapeoplepg-inline-38 {\n  background: #fffbeb;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #d97706;\n}\n\n.itapeoplepg-dyn-1 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  background: var(--itapeoplepg-1-background);\n  color: var(--itapeoplepg-1-color);\n}\n\n.itapeoplepg-dyn-2 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  background: var(--itapeoplepg-2-background);\n  color: var(--itapeoplepg-2-color);\n}\n\n.itapeoplepg-dyn-3 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  background: var(--itapeoplepg-3-background);\n  color: var(--itapeoplepg-3-color);\n}\n\n.itapeoplepg-dyn-4 {\n  position: absolute;\n  top: var(--itapeoplepg-4-top);\n  right: var(--itapeoplepg-4-right);\n  width: 140px;\n  height: 140px;\n  background: radial-gradient(circle,rgba(99,102,241,.15),transparent 70%);\n  border-radius: 50%;\n}\n\n.itapeoplepg-dyn-5 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  background: var(--itapeoplepg-5-background);\n  color: var(--itapeoplepg-5-color);\n}\n\n.itapeoplepg-dyn-6 {\n  font-size: 12px;\n  font-weight: 600;\n  font-family: var(--itapeoplepg-6-font-family);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
